import React, { useState } from 'react';
import PropTypes from 'prop-types';

import DangerString from '../../common/components/danger-string';
import IString from '../../common/components/i-string';
import WaitButton from '../../common/components/wait-button';

import { translate } from '../../common/i18n/localize';

const PROMPT = 'prompt_screen';
const FORM = 'form_screen';

function ChangeLoginForm(props) {
  const { email, ssoInfo, onSubmit } = props;

  const [screen, setScreen] = useState(PROMPT);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(e.target.email.value);
  };

  return (
    <>
      { screen === PROMPT &&
        <div className='bigMarginAbove formish'>
          <p className='noMarginBelow'>
            <IString stringKey='sso.change.prompt' placeholders={{
              button: 
                <button className='standardLink inline' onClick={() => setScreen(FORM)} type='button'>
                  <IString stringKey='sso.change.login' />
                </button>,
              name: ssoInfo?.name }} />
          </p>
        </div> }

      { screen === FORM &&
        <form className='bigMarginAbove' onSubmit={handleSubmit}>
          <DangerString stringKey='sso.change.message' placeholders={{ name: ssoInfo?.name }} trustPlaceholders />
          { email ? 
            <input name='email' type='hidden' value={email} />
            : <fieldset className='chunk'>
              <input name='email' type='email' placeholder={translate('sso.change.email')} required />
            </fieldset> }

          <fieldset className='actions midMarginAbove'>
            <WaitButton className='noSubmitLook' type='submit'>
              <IString stringKey='sso.change.submit' />
            </WaitButton>
          </fieldset>
        </form> }
    </>
  );
}

ChangeLoginForm.propTypes = {
  email: PropTypes.string,
  onSubmit: PropTypes.func,
  ssoInfo: PropTypes.shape({
    name: PropTypes.string
  })
};

export default ChangeLoginForm;
